import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetUsersWithQuotas as GetUsersWithQuotasQuery,
    GetUsersWithQuotasVariables,
    UserQuotaFragment,
} from 'nutshell-graphql-types';

import {START_YEAR} from '../../helpers';

import GET_USERS_WITH_QUOTAS from '../queries/get-users-with-quotas.graphql';

export const LIMIT = 100;

export const QUERY_VARIABLES = {
    first: LIMIT,
    minFiscalYear: START_YEAR,
};

export function useGetUsersWithQuotas(): {
    users: UserQuotaFragment[];
    isLoading: boolean;
    errorMessage: string | null | undefined;
    hasNextPage: boolean;
    refetch: () => Promise<any>;
} {
    const {data, loading, error, refetch} = useQuery<
        GetUsersWithQuotasQuery,
        GetUsersWithQuotasVariables
    >(GET_USERS_WITH_QUOTAS, {
        variables: QUERY_VARIABLES,
        fetchPolicy: 'cache-and-network',
    });

    const connection = data?.usersWithQuotas ?? null;
    const hasNextPage = connection?.pageInfo.hasNextPage ?? false;

    return {
        users: connection ? connection.edges.map((edge) => edge.node) : [],
        isLoading: loading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        hasNextPage,
        refetch,
    };
}
